import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ContractCard = ({ contract, isSelected, onClick, userRole }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'bg-error text-error-foreground';
      case 'high':
        return 'bg-warning text-warning-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending_review':
        return 'bg-warning/20 text-warning border-warning/30';
      case 'approved':
        return 'bg-success/20 text-success border-success/30';
      case 'rejected':
        return 'bg-error/20 text-error border-error/30';
      case 'in_progress':
        return 'bg-accent/20 text-accent-foreground border-accent/30';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const canApprove = () => {
    if (userRole === 'admin') return true;
    if (userRole === 'contract_specialist' && contract?.currentStage === 'legal_review') return true;
    return false;
  };

  return (
    <div
      onClick={onClick}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-250 hover:shadow-warm-md ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-warm'
          : 'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Image
            src={contract?.propertyImage}
            alt={contract?.propertyImageAlt}
            className="w-12 h-12 md:w-14 md:h-14 rounded-lg object-cover flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <h3 className="text-sm md:text-base font-semibold text-foreground truncate">
              {contract?.propertyTitle}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground truncate">
              {contract?.clientName}
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getPriorityColor(contract?.priority)}`}>
          {contract?.priorityLabel}
        </span>
      </div>
      <div className="flex items-center gap-2 mb-3">
        <span className={`px-3 py-1 rounded-lg text-xs font-medium border ${getStatusColor(contract?.status)}`}>
          {contract?.statusLabel}
        </span>
        <span className="text-xs text-muted-foreground font-data">
          {contract?.contractNumber}
        </span>
      </div>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <Icon name="Calendar" size={14} />
          <span>{contract?.submittedDate}</span>
        </div>
        {canApprove() && (
          <div className="flex items-center gap-1 text-primary">
            <Icon name="CheckCircle" size={14} />
            <span className="font-medium">يتطلب موافقتك</span>
          </div>
        )}
      </div>
      {contract?.daysWaiting > 0 && (
        <div className="mt-2 pt-2 border-t border-border">
          <div className="flex items-center gap-1 text-xs text-warning">
            <Icon name="Clock" size={14} />
            <span>في الانتظار منذ {contract?.daysWaiting} يوم</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractCard;